import { useEffect } from 'react';
import { OVERLAY_ID } from '@activebrands/core-web/config/overlay';
import overlay from '@activebrands/core-web/libs/overlay';
import { removePageQueryParams } from '@activebrands/core-web/utils/remove-page-query-params';
import extractQueryParams from '@grebban/utils/string/extractQueryParams';

const REACT_APP_SIGN_IN_QUERY_PARAM = process.env.REACT_APP_SIGN_IN_QUERY_PARAM || '';
const REACT_APP_SIGN_UP_QUERY_PARAM = process.env.REACT_APP_SIGN_UP_QUERY_PARAM || '';

const useSignInSignUpQueryParams = () => {
    useEffect(() => {
        const queryParams = extractQueryParams(window?.location?.search);
        const openSignInOverlay = queryParams[REACT_APP_SIGN_IN_QUERY_PARAM] === true;
        const openSignUpOverlay = queryParams[REACT_APP_SIGN_UP_QUERY_PARAM] === true;

        if (!openSignInOverlay && !openSignUpOverlay) return;

        requestAnimationFrame(() => {
            if (openSignInOverlay) {
                overlay.open(OVERLAY_ID.UNAUTHENTICATED, {
                    form: 'sign-in',
                    redirect: false,
                });
                removePageQueryParams([REACT_APP_SIGN_IN_QUERY_PARAM]);
            }
            if (openSignUpOverlay) {
                overlay.open(OVERLAY_ID.UNAUTHENTICATED, {
                    form: 'sign-up-step-one',
                    resetId: 'new-member',
                });
                removePageQueryParams([REACT_APP_SIGN_UP_QUERY_PARAM]);
            }
        });
    }, []);
};

export default useSignInSignUpQueryParams;
